module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.6224/images/default-avatar.png"